import CloseIcon from "@mui/icons-material/Close";
import { Box, Container, Dialog } from "@mui/material";

import { LanguageSwitch } from "@components/languageSwitch";

import { TextLogoStyled } from "./Menu.styled";
import MenuIcon from "./menu.svg";
import { MenuLinks } from "./MenuLinks";
import { ThemeSwitch } from "./ThemeSwitch";

interface MobileMenuProps {
  opened: boolean;
  setOpened: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MobileMenu = ({ opened, setOpened }: MobileMenuProps) => {
  return (
    <>
      <MenuIcon className="h-[20px] w-[20px]" onClick={() => setOpened(true)} />

      {opened && (
        <Dialog open={opened} onClose={() => setOpened(false)} fullScreen>
          <Container
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              py: "16px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingX: "1rem",
              }}
            >
              <TextLogoStyled />

              <CloseIcon onClick={() => setOpened(false)} height="19px" />
            </Box>

            <Box
              sx={{
                "display": "flex",
                "flexDirection": "column",
                "justifyContent": "space-between",
                "gap": "48px",
                "alignItems": "center",
                ".MuiTypography-root": {
                  textAlign: "center",
                  display: "block",
                },
              }}
            >
              <MenuLinks />
            </Box>

            <Box
              sx={{
                "display": "flex",
                "flexDirection": "column",
                "justifyContent": "space-between",
                "gap": "48px",
                "alignItems": "center",
                ".MuiTypography-root": {
                  textAlign: "center",
                  display: "block",
                },
              }}
            >
              <ThemeSwitch />
              <LanguageSwitch variant="navigation1" />
            </Box>
          </Container>
        </Dialog>
      )}
    </>
  );
};
